import { useEffect, useState } from 'react'
import UIStore from 'states/globalStore'

import servicesUtils from '../servicesUtils'
import backendChecks from '../backendChecks'

function getLicense() {
  return servicesUtils.getService(`/qxr/license/`)
}

function useLicense(authData) {
  const [licenses, setLicenses] = useState(null)
  const [error, setError] = useState(null)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    const userRoles = backendChecks.getAllRoles(authData)
    const hasRoleOtherThanRadiologist =
      userRoles.hasAdminRole ||
      userRoles.hasHealthWorkerRole ||
      userRoles.hasProgramManagerRole

    if (!authData || !hasRoleOtherThanRadiologist) {
      setLoading(false)
      return null
    }

    getLicense()
      .then(data => {
        setLoading(false)
        setLicenses(data)
        UIStore.update(s => {
          // eslint-disable-next-line no-param-reassign
          s.qxrLicense = data
        })
      })
      .catch(err => {
        setLoading(false)
        UIStore.update(s => {
          // eslint-disable-next-line no-param-reassign
          s.qxrLicense = {}
        })
        setError(err)
      })
  }, [authData])

  return { licenses, isLoading, error }
}

export default useLicense
